import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '邪娠娼馆 | 暗黑情色文学世界观完全指南',
            description:
              '深入探索「邪娠娼馆」的世界观设定、人物关系与剧情脉络。汇聚核心故事背景、角色图鉴与创作解析。',
            url: 'https://hnbocong.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '邪娠娼馆世界观指南',
              url: 'https://hnbocong.cn/',
            },
            primaryImageOfPage: {
              '@type': 'ImageObject',
              contentUrl:
                'https://readdy.ai/api/search-image?query=Dark%20gothic%20mansion%20silhouette%20against%20blood%20red%20moon%2C%20ancient%20Victorian%20architecture%2C%20misty%20atmosphere&width=1920&height=1080&seq=hero-bg-01&orientation=landscape',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '「邪娠娼馆」是什么类型的作品？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '「邪娠娼馆」是一部暗黑奇幻风格的成人向文学作品，融合了哥特恐怖、情色叙事与心理惊悚元素。',
                },
              },
              {
                '@type': 'Question',
                name: '这部作品的创作背景是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '作品诞生于对传统奇幻文学范式的不满与反思，深受哥特文学传统、日本暗黑美学以及现代心理小说的多重影响。',
                },
              },
              {
                '@type': 'Question',
                name: '如何理解作品中的「契约魔法」体系？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '契约魔法与传统奇幻中「天赋施法」不同，这里的魔法必须以「代价」换取——血液、记忆、情感、甚至存在本身。',
                },
              },
              {
                '@type': 'Question',
                name: '作品中有多少个主要角色？她们的命运走向如何？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '作品拥有超过二十个有名有姓的角色，其中核心角色约八人。每个角色的命运都与娼馆的运作机制紧密相连。',
                },
              },
              {
                '@type': 'Question',
                name: '作品的结局是否已经确定？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '故事仍在连载中，最终结局尚未公布。目前已有超过七种主流的结局推论。',
                },
              },
              {
                '@type': 'Question',
                name: '这个网站的内容来源是什么？如何保证分析的准确性？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '本站所有内容均由资深读者团队基于原文文本进行系统梳理和深度分析，每篇解析文章都标注了所引用的具体章节和段落。',
                },
              },
            ],
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedArticles />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}